import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElButton, ElIcon } from 'element-plus';

import TelegramIcon from '@/components/icons/Telegram.vue';

const ENABLE_BUTTON_DELAY = 3000;


export default /*@__PURE__*/_defineComponent({
  __name: 'TelegramButton',
  props: {
    username: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const hasInteracted = ref(false);
const isDelayPassed = ref(false);

const link = computed(() => (isDisabled.value ? '#' : `https://t.me/${props.username}`));
const isDisabled = computed(() => !hasInteracted.value || !isDelayPassed.value);

const markInteraction = () => {
  hasInteracted.value = true;
  removeEventListeners();
};

const removeEventListeners = () => {
  window.removeEventListener('mousemove', markInteraction);
  window.removeEventListener('scroll', markInteraction);
  window.removeEventListener('keydown', markInteraction);
  window.removeEventListener('touchstart', markInteraction);
};

onMounted(() => {
  setTimeout(() => {
    isDelayPassed.value = true;
    removeEventListeners();
  }, ENABLE_BUTTON_DELAY);

  window.addEventListener('mousemove', markInteraction, { once: true });
  window.addEventListener('scroll', markInteraction, { once: true });
  window.addEventListener('keydown', markInteraction, { once: true });
  window.addEventListener('touchstart', markInteraction, { once: true });
});

onUnmounted(() => {
  removeEventListeners();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElButton), {
    tag: "a",
    type: "primary",
    size: "small",
    class: "ui-btn1 telegram-button",
    disabled: isDisabled.value,
    href: link.value,
    target: "_blank"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ElIcon), null, {
        default: _withCtx(() => [
          _createVNode(TelegramIcon)
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_unref(t)('btnWriteToTelegramBot')), 1)
    ]),
    _: 1
  }, 8, ["disabled", "href"]))
}
}

})